import { render, staticRenderFns } from "./setores-exame.vue?vue&type=template&id=6906b9ed&"
import script from "./setores-exame.vue?vue&type=script&lang=js&"
export * from "./setores-exame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports